import * as React from 'react';
/**
 *
 * Original name: browser
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29934%3A6860
 *
 */
export const BrowserPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M48 31H34v4h14v-4Zm-32 .007h14V43H16V31.007ZM48 39H34v4h14v-4Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.002 14.005 47.996.002V23H56v4h-.002v24.004H8.002V14.006Zm43.996 4.001V23H12.002v-4.994h39.996ZM12.002 47.004V27h39.996v20.004H12.002Z", fill: "currentColor" })));
